import { Box } from "@mui/material";
import { useState } from "react";
import ComfyUIIcon from "../../../assets/Integrations/icons/comfyui.png";
import FigmaIcon from "../../../assets/Integrations/icons/figma.png";
import PhotoshopIcon from "../../../assets/Integrations/icons/photoshop.png";
import MCPIcon from "../../../assets/images/pngs/mcp-logo.png";
import APIIcon from "../../../assets/images/svgs/PlaygroundHub/api-window.svg";
import SourceCodeCircleIcon from "../../../assets/images/svgs/PlaygroundHub/source-code-circle.svg";
import IframeIcon from "../../../assets/images/svgs/TgAccessMethods/iframe.svg";
import { OverviewIntegrationOption } from "../../../components/Home/Overview/Integrations/OverviewIntegrations";
import {
	IntegrationIconCard,
	IntegrationIconCardProps,
} from "../../../components/common/IntegrationIconCard/IntegrationIconCard";
import LinkConstants from "../../../constants/LinkConstants";
import RouterConstants from "../../../constants/RouterConstants";
import { useAppStore } from "../../../hooks/useStores";
import PhotoshopInstallationPopup from "../../NewTG/Models/Popups/PhotoshopInstallationPopup/PhotoshopInstallationPopup";
import styles from "./HubIntegrations.module.scss";

export type IntegrationOption = OverviewIntegrationOption | "API" | "MCP_SERVER" | "SOURCE_CODE" | "IFRAME";
export interface IHubIntegrationsProps {
	integrations: IntegrationOption[];
}

export const HubIntegrations = ({ integrations }: IHubIntegrationsProps) => {
	const { appStore } = useAppStore();
	const [photoshopPopupState, setPhotoshopPopupState] = useState<boolean>(false);
	const integrationsConfig: Partial<Record<IntegrationOption, IntegrationIconCardProps>> = {
		API: {
			icon: APIIcon,
			label: "API",
			link: LinkConstants.BRIA_API,
		},
		IFRAME: {
			icon: IframeIcon,
			label: "Iframe",
			link: RouterConstants.ACCOUNT_IFRAMES.fullPath,
		},
		SOURCE_CODE: {
			icon: SourceCodeCircleIcon,
			label: "Source Code",
			link: RouterConstants.MODELS.OVERVIEW.fullPath,
		},
		MCP_SERVER: {
			icon: MCPIcon,
			label: "MCP",
			link: RouterConstants.IMAGE_EDITING.McpSERVER.fullPath,
		},
		COMFY_UI: {
			icon: ComfyUIIcon,
			label: "ComfyUI",
			link: LinkConstants.BRIA_COMFYUI.GIT,
		},
		FIGMA: {
			icon: FigmaIcon,
			label: "Figma",
			link: RouterConstants.IMAGE_GENERATION.FIGMA.fullPath,
		},
		PHOTOSHOP: {
			icon: PhotoshopIcon,
			label: "Photoshop",
			onClick: () => setPhotoshopPopupState(true),
		},
	};

	return (
		<Box className={styles.integrationsRow}>
			{integrations.map((integration: IntegrationOption) => {
				const integrationProps: IntegrationIconCardProps | undefined = integrationsConfig[integration];
				return (
					(integrationProps as IntegrationIconCardProps)?.icon && (
						<IntegrationIconCard
							key={integration}
							className={styles.wideCard}
							{...(integrationProps as IntegrationIconCardProps)}
						/>
					)
				);
			})}

			<PhotoshopInstallationPopup
				open={photoshopPopupState}
				onClose={() => setPhotoshopPopupState(false)}
				onClick={() => {
					window.open(LinkConstants.ADOBE_MARKETPLACE, "_blank");
					appStore.logPhotoshopGoToAdobeMarketplace();
				}}
			/>
		</Box>
	);
};
